import React from 'react';
import { LDSingleKindContext, asyncWithLDProvider, useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { LDClient } from 'launchdarkly-js-client-sdk';
import { getFormattedUserObject } from './utils';

/**
 * A React context
 */
export const withFeatureFlagProvider = async (token: string) => {
	if (!token) {
		return Promise.resolve((props: React.PropsWithChildren) => <>{props.children}</>);
	}
	return await asyncWithLDProvider({
		clientSideID: token,
		context: {
			anonymous: true,
			key: 'u:reactweb',
			kind: 'user'
		},
		options: {
			streaming: true
		},
		reactOptions: {
			useCamelCaseFlagKeys: false
		}
	});
};

export type User = {
	actType: 'admin' | 'supervisor' | null;
	anonymous: boolean;
	key: string;
	kind: string;
	firstName: string;
	lastName: string;
	email: string;
	roleID: number;
	orgID: number;
	locID: number;
	dptID: number;
	isTestUser: boolean;
	isTestOrg: boolean;
	state: string;
};

const withClient = (client?: LDClient) => async (user: Partial<LDSingleKindContext>) => {
	await client?.identify(getFormattedUserObject(user));
};

export const useFeatureFlags = () => {
	const allFlags = useFlags();
	const client = useLDClient();

	const updateUser = withClient(client);

	return {
		allFlags,
		updateUser
	};
};
